export default __webpack_public_path__ + "static/media/quora.93d62dd8.svg";